<template>
    <div>
        <div class="service-tabs" v-if="!COMMON.isMobile">
            <div class="tabs-list container">
                <ul>
                    <li
                        v-for="(item,index) in innerMenu"
                        v-bind:key="index"
                        v-bind:class="{on: item.isCur}"
                    >
                        <router-link :to="{name:item.name}">{{item.title}}</router-link>
                    </li>
                </ul>
            </div>
        </div>
        <router-view :mobileWidth="mobileWidth"></router-view>
    </div>
</template>
<script>
export default {
    name: 'service-index',
    props: ['mobileWidth'],
    data() {
        return {
            outerTab: 'order',
            innerMenu: [
                {
                    isCur: true,
                    name: 'order',
                    title: '运单查询'
                },
                {
                    isCur: false,
                    name: 'wharehouse',
                    title: '营业网点'
                },
                {
                    isCur: false,
                    name: 'branch',
                    title: '联系客服'
                }
            ]
        };
    },
    methods: {
        changeTab(tabname) {
            this.innerMenu.map(item => {
                if (item.name === tabname) {
                    item.isCur = true;
                } else {
                    item.isCur = false;
                }
            });

            if (tabname === this.outerTab) {
                this.innerMenu[0].isCur = true;
            }
        }
    },
    mounted() {
        const tabname = this.$route.name || this.innerMenu[0].name;
        this.changeTab(tabname);
    },
    watch: {
        $route: function() {
            const tabname = this.$route.name || this.innerMenu[0].name;
            this.changeTab(tabname);
        }
    }
};
</script>
<style lang="less">
.service-tabs {
    height: .8rem;
    background-color: #2c2f37;
    .tabs-list {
        text-align: center;
    }
    ul {
        li {
            display: inline-block;
            text-align: center;
            line-height: 0.16rem;
            font-size: 18px;
            padding: 0 .1rem;
            margin: 0 .1rem;
        }
    }
    a {
        height: 0.16rem;
        display: -webkit-box;
        color: #999999;
        padding: 0.32rem 0.4rem 0.13rem;
    }
    .on {
        border-bottom: #ff8b00 0.02rem solid;
        a {
            color: #fffffe;
        }
    }
}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .service-tabs ul li {
        font-size: 16px;
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .service-tabs ul li {
        font-size: 14px;
    }
}

@media screen and (max-width: 480px) {
    .service-tabs {
        height: .5rem;
        border-bottom: #f6f6f6 solid 1px;
        ul {
            margin-top: 0rem;
            li {
                font-size: 16px;
            }
        }
        a {
            height: 0.5rem;
            width: 100%;
            display: inline-block;
            color: #999999;
        }
        .on {
            border-bottom: #ff8b00 0.02rem solid;
            a {
                color: #ff8b00;
            }
        }
    }
}
</style>
